module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("课程管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("课后习题")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "labe-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "教材版本："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "on-change": _vm.medition
    },
    model: {
      value: (_vm.queryParam.materialVersion),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "materialVersion", $$v)
      },
      expression: "queryParam.materialVersion"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程等级："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.changeLevel
    },
    model: {
      value: (_vm.queryParam.levelItem),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "levelItem", $$v)
      },
      expression: "queryParam.levelItem"
    }
  }, _vm._l((_vm.levelAll), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程标题："
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.lessonItem),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lessonItem", $$v)
      },
      expression: "queryParam.lessonItem"
    }
  }, _vm._l((_vm.lessonAll), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课后题标题：",
      "label-width": 100
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊查询"
    },
    model: {
      value: (_vm.queryParam.title),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "title", $$v)
      },
      expression: "queryParam.title"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('Col')], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_vm._v("添加课后习题\n          ")])], 1), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.title,
      "listUrl": "/bookLessonNewReview/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "课后习题",
      "scrollable": true,
      "styles": {
        top: '60px',
        marginBottom: '50px'
      },
      "width": "1000"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form formModal",
    staticStyle: {
      "overflow": "visible",
      "height": "auto"
    },
    attrs: {
      "model": _vm.formDate,
      "rules": _vm.ruleLevelGrade,
      "label-width": 80
    }
  }, [_c('Row', [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "教材版本：",
      "prop": "materialVersion",
      "label-width": 110
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "transfer": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.meditions
    },
    model: {
      value: (_vm.formDate.materialVersion),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "materialVersion", $$v)
      },
      expression: "formDate.materialVersion"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择level：",
      "label-width": 110,
      "prop": "levelItem"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeModelLevel
    },
    model: {
      value: (_vm.formDate.levelItem),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "levelItem", $$v)
      },
      expression: "formDate.levelItem"
    }
  }, _vm._l((_vm.levelAlls), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择对应课程：",
      "label-width": 110,
      "prop": "lessonItem",
      "transfer": ""
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formDate.lessonItem),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "lessonItem", $$v)
      },
      expression: "formDate.lessonItem"
    }
  }, _vm._l((_vm.lessonAlls), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "序号：",
      "prop": "sort",
      "label-width": 110
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formDate.sort),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "sort", _vm._n($$v))
      },
      expression: "formDate.sort"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "考核能力：",
      "label-width": 110,
      "transfer": ""
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formDate.appraise),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "appraise", $$v)
      },
      expression: "formDate.appraise"
    }
  }, _vm._l((_vm.$constant.appraise), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题型：",
      "label-width": 110,
      "transfer": ""
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeQuestionType
    },
    model: {
      value: (_vm.formDate.questionType),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "questionType", $$v)
      },
      expression: "formDate.questionType"
    }
  }, _vm._l((_vm.$constant.questionType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 110,
      "transfer": ""
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeQuestionDev
    },
    model: {
      value: (_vm.formDate.questionDev),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "questionDev", $$v)
      },
      expression: "formDate.questionDev"
    }
  }, _vm._l((_vm.questionDevList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标题：",
      "prop": "title",
      "label-width": 110
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formDate.title),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "title", $$v)
      },
      expression: "formDate.title"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "主内容：",
      "label-width": 110
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formDate.content),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "content", $$v)
      },
      expression: "formDate.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.formDate.questionType === 3 && _vm.formDate.questionDev === 1) ? _c('Row', _vm._l((_vm.answerList.length), function(index) {
    return _c('Row', [_c('i-col', {
      attrs: {
        "span": 22
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.SecondlyContext + index,
        "label-width": 110
      }
    }, [_c('Input', {
      model: {
        value: (_vm.manyContext[index]),
        callback: function($$v) {
          _vm.$set(_vm.manyContext, index, $$v)
        },
        expression: "manyContext[index]"
      }
    })], 1)], 1)], 1)
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('Row', [(_vm.formDate.questionType === 1 || (_vm.formDate.questionType === 2 && _vm.formDate.questionDev === 2)) ? _c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "45px",
      "color": "#e60000"
    }
  }, [_vm._v("图片尺寸：894 X 370 (请按照规范上传)")]) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 2 && _vm.formDate.questionDev === 1) ? _c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "45px",
      "color": "#e60000"
    }
  }, [_vm._v("图片尺寸：475 X 472 (请按照规范上传)")]) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 2 && _vm.formDate.questionDev === 3) ? _c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "45px",
      "color": "#e60000"
    }
  }, [_vm._v("图片尺寸：372 X 213 (请按照规范上传)")]) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 3 && _vm.formDate.questionDev === 1) ? _c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "45px",
      "color": "#e60000"
    }
  }, [_vm._v("图片尺寸：542 X 309 (请按照规范上传)")]) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 3 && _vm.formDate.questionDev === 2) ? _c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "45px",
      "color": "#e60000"
    }
  }, [_vm._v("图片尺寸：917 X 288 (请按照规范上传)")]) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 6
    }
  }, [_c('i-col', {
    attrs: {
      "span": 9
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "图片"
    }
  }, [_c('image-upload', {
    attrs: {
      "defaultFileList": _vm.defaultPicList,
      "text": "上传图片"
    },
    model: {
      value: (_vm.formDate.pic),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "pic", $$v)
      },
      expression: "formDate.pic"
    }
  })], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "音频"
    }
  }, [_c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('file-upload', {
    attrs: {
      "defaultFileList": _vm.defaultAudioList,
      "text": "上传音频",
      "accept": "audio/*"
    },
    model: {
      value: (_vm.formDate.video),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "video", $$v)
      },
      expression: "formDate.video"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.formDate.questionType === 3 && _vm.formDate.questionDev === 2) ? _c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "45px",
      "color": "#e60000"
    }
  }, [_vm._v("车过桥类型：答案图片上传时不管是3张图片或4张图片宽度总和要为361,高度每张为179")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.formDate.questionType === 2 && _vm.formDate.questionDev === 3) ? _c('Row', [_c('Row', [_c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "45px",
      "color": "#e60000"
    }
  }, [_vm._v("图片尺寸：185 X 215 (请按照规范上传)")]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "拼图"
    }
  }, [_c('image-upload', {
    attrs: {
      "defaultFileList": _vm.pinPicList,
      "text": "上传图片"
    },
    model: {
      value: (_vm.formDate.pinPic),
      callback: function($$v) {
        _vm.$set(_vm.formDate, "pinPic", $$v)
      },
      expression: "formDate.pinPic"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 1) ? _c('Row', [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "答案：",
      "label-width": 110
    }
  }, [_c('Input', {
    model: {
      value: (_vm.answerMore[0]),
      callback: function($$v) {
        _vm.$set(_vm.answerMore, 0, $$v)
      },
      expression: "answerMore[0]"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [(_vm.formDate.questionType === 2 && _vm.formDate.questionDev === 1) ? _c('Row', [_vm._l((_vm.formDate.levelQuestionSelectOneList), function(item, index) {
    return [_c('Row', [_c('i-col', {
      attrs: {
        "span": 22
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.text + (index + 1),
        "label-width": 110
      }
    }, [_c('Input', {
      model: {
        value: (item.info),
        callback: function($$v) {
          _vm.$set(item, "info", $$v)
        },
        expression: "item.info"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
      attrs: {
        "gutter": 6
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block",
        "padding-left": "45px",
        "color": "#e60000"
      }
    }, [_vm._v("图片尺寸：271 X 178 (请按照规范上传)")]), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 9
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "图片"
      }
    }, [_c('image-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultImages[index],
        "text": "上传图片"
      },
      model: {
        value: (item.pic),
        callback: function($$v) {
          _vm.$set(item, "pic", $$v)
        },
        expression: "item.pic"
      }
    })], 1)], 1), _vm._v(" "), _c('Form-item', {
      attrs: {
        "label": "音频"
      }
    }, [_c('i-col', {
      attrs: {
        "span": 6
      }
    }, [_c('file-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultVideo[index],
        "text": "上传音频",
        "accept": "audio/*"
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)], 1)], 1)]
  }), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "答案：",
      "label-width": 110,
      "transfer": ""
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.answerMore[0]),
      callback: function($$v) {
        _vm.$set(_vm.answerMore, 0, $$v)
      },
      expression: "answerMore[0]"
    }
  }, _vm._l((_vm.$constant.questionAnswer), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 2 && _vm.formDate.questionDev === 2) ? _c('Row', [_vm._l((_vm.formDate.levelQuestionSelectOneList), function(item, index) {
    return [_c('Row', [_c('i-col', {
      attrs: {
        "span": 22
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.text + (index + 1),
        "label-width": 110
      }
    }, [_c('Input', {
      model: {
        value: (item.info),
        callback: function($$v) {
          _vm.$set(item, "info", $$v)
        },
        expression: "item.info"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
      attrs: {
        "gutter": 6
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "音频"
      }
    }, [_c('i-col', {
      attrs: {
        "span": 6
      }
    }, [_c('file-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultVideo[index],
        "text": "上传音频",
        "accept": "audio/*"
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)], 1)], 1)]
  }), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "答案：",
      "label-width": 110,
      "transfer": ""
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.answerMore[0]),
      callback: function($$v) {
        _vm.$set(_vm.answerMore, 0, $$v)
      },
      expression: "answerMore[0]"
    }
  }, _vm._l((_vm.$constant.questionAnswer), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 2 && _vm.formDate.questionDev === 3) ? _c('Row', [_vm._l((_vm.formDate.levelQuestionSelectOneList), function(item, index) {
    return [_c('span', [_vm._v("选项" + _vm._s(index + 1))]), _vm._v(" "), _c('Row', {
      attrs: {
        "gutter": 6
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block",
        "padding-left": "45px",
        "color": "#e60000"
      }
    }, [_vm._v("图片尺寸 235 X 216 (请按照规范上传)")]), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 9
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "图片"
      }
    }, [_c('image-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultImages[index],
        "text": "上传图片"
      },
      model: {
        value: (item.pic),
        callback: function($$v) {
          _vm.$set(item, "pic", $$v)
        },
        expression: "item.pic"
      }
    })], 1)], 1), _vm._v(" "), _c('Form-item', {
      attrs: {
        "label": "音频"
      }
    }, [_c('i-col', {
      attrs: {
        "span": 6
      }
    }, [_c('file-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultVideo[index],
        "text": "上传音频",
        "accept": "audio/*"
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)], 1)], 1)]
  }), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "答案：",
      "label-width": 110,
      "transfer": ""
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.answerMore[0]),
      callback: function($$v) {
        _vm.$set(_vm.answerMore, 0, $$v)
      },
      expression: "answerMore[0]"
    }
  }, _vm._l((_vm.$constant.questionAnswer), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 3 && _vm.formDate.questionDev === 1) ? _c('Row', [_vm._l((_vm.formDate.levelQuestionSelectOneList), function(item, index) {
    return [_c('Row', {
      attrs: {
        "gutter": 6
      }
    }, [_c('i-col', {
      attrs: {
        "span": 22
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.text + (index + 1),
        "label-width": 110
      }
    }, [_c('Input', {
      model: {
        value: (item.info),
        callback: function($$v) {
          _vm.$set(item, "info", $$v)
        },
        expression: "item.info"
      }
    })], 1)], 1), _vm._v(" "), _c('Form-item', {
      attrs: {
        "label": "音频"
      }
    }, [_c('i-col', {
      attrs: {
        "span": 6
      }
    }, [_c('file-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultVideo[index],
        "text": "上传音频",
        "accept": "audio/*"
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)], 1)], 1)]
  }), _vm._v(" "), _vm._l((_vm.answerList), function(item, index) {
    return [_c('Row', [_c('i-col', {
      attrs: {
        "span": 22
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.answerText + (index + 1),
        "label-width": 110,
        "transfer": ""
      }
    }, [_c('Select', {
      attrs: {
        "transfer": ""
      },
      model: {
        value: (_vm.answerMore[index]),
        callback: function($$v) {
          _vm.$set(_vm.answerMore, index, $$v)
        },
        expression: "answerMore[index]"
      }
    }, _vm._l((_vm.$constant.questionAnswer), function(item) {
      return _c('Option', {
        key: item.code,
        attrs: {
          "value": item.code
        }
      }, [_vm._v(_vm._s(item.text))])
    }), 1)], 1)], 1)], 1)]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.formDate.questionType === 3 && _vm.formDate.questionDev === 2) ? _c('Row', [_vm._l((_vm.formDate.levelQuestionSelectOneList), function(item, index) {
    return [_c('span', [_vm._v("选项" + _vm._s(index + 1))]), _vm._v(" "), _c('Row', {
      attrs: {
        "gutter": 6
      }
    }, [_c('i-col', {
      attrs: {
        "span": 9
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "图片"
      }
    }, [_c('image-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultImages[index],
        "text": "上传图片"
      },
      model: {
        value: (item.pic),
        callback: function($$v) {
          _vm.$set(item, "pic", $$v)
        },
        expression: "item.pic"
      }
    })], 1)], 1), _vm._v(" "), _c('Form-item', {
      attrs: {
        "label": "音频"
      }
    }, [_c('i-col', {
      attrs: {
        "span": 6
      }
    }, [_c('file-upload', {
      attrs: {
        "defaultFileList": _vm.selectDefaultVideo[index],
        "text": "上传音频",
        "accept": "audio/*"
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)], 1)], 1)]
  }), _vm._v(" "), _vm._l((_vm.answerList), function(item, index) {
    return [_c('Row', [_c('i-col', {
      attrs: {
        "span": 22
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.answerText + (index + 1),
        "label-width": 110,
        "transfer": ""
      }
    }, [_c('Select', {
      attrs: {
        "transfer": ""
      },
      model: {
        value: (_vm.answerMore[index]),
        callback: function($$v) {
          _vm.$set(_vm.answerMore, index, $$v)
        },
        expression: "answerMore[index]"
      }
    }, _vm._l((_vm.$constant.questionAnswer), function(item) {
      return _c('Option', {
        key: item.code,
        attrs: {
          "value": item.code
        }
      }, [_vm._v(_vm._s(item.text))])
    }), 1)], 1)], 1)], 1)]
  })], 2) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.insert
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14eb6a02","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/course/ClassReview.vue
// module id = 1653
// module chunks = 8